<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start" class="mobile-theme-toggle">
      <ion-button fill="clear" (click)="toggleTheme()" [attr.aria-label]="'SETUP.THEME' | translate">
        <ion-icon [name]="darkMode ? 'moon' : 'sunny'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'PLAYLISTS.TITLE' | translate }}</ion-title>
    <ion-buttons slot="end" class="mobile-language-toggle">
      <ion-button fill="clear" (click)="goToBeginning()" [attr.aria-label]="'SETTINGS.NATIVE_LANGUAGE' | translate">
        <span class="language-flag" aria-hidden="true">{{ nativeLanguageFlag }}</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item button (click)="openLanguagePicker()" detail="false" lines="full">
    <ion-icon name="language-outline" slot="start"></ion-icon>
    <ion-label>{{ 'PLAYLISTS.LANGUAGE_LABEL' | translate }}</ion-label>
    <ion-note slot="end">{{ languageDisplayName }}</ion-note>
    <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
  </ion-item>

  <div class="search-wrapper">
    <ion-searchbar
      [placeholder]="'PLAYLISTS.SEARCH_PLACEHOLDER' | translate"
      [value]="searchQuery"
      (ionInput)="onSearch($event)"
      (ionClear)="onSearch({detail:{value:''}})"
      debounce="150"
      animated>
    </ion-searchbar>
    <ion-button
      *ngIf="hasBookmarkedPlaylists"
      size="small"
      [fill]="showBookmarkedOnly ? 'solid' : 'outline'"
      color="primary"
      class="pinned-filter-btn"
      (click)="toggleBookmarkedFilter()">
      <ion-icon name="bookmark" slot="start"></ion-icon>
      {{ 'PLAYLISTS.BOOKMARKED' | translate }}
    </ion-button>
  </div>

  <p *ngIf="filteredPlaylists.length === 0 && !searchQuery && !showBookmarkedOnly" class="no-results">{{ 'PLAYLISTS.NO_FEATURED' | translate }}</p>
  <p *ngIf="filteredPlaylists.length === 0 && searchQuery" class="no-results">{{ 'PLAYLISTS.NO_RESULTS' | translate:{query: searchQuery} }}</p>
  <p *ngIf="filteredPlaylists.length === 0 && showBookmarkedOnly && !searchQuery" class="no-results">{{ 'PLAYLISTS.NO_BOOKMARKED' | translate }}</p>

  <div class="playlists-grid">
    <ion-card *ngFor="let playlist of filteredPlaylists" button (click)="navigateToPlaylist(playlist)">
      <ion-card-header>
        <ion-card-title>
          <ion-icon *ngIf="playlist.visibility === 'private'" name="lock-closed-outline" class="vis-icon" title="Private"></ion-icon>
          <ion-icon *ngIf="playlist.visibility === 'link'" name="link-outline" class="vis-icon" title="Anyone with link"></ion-icon>
          {{ playlist.name }}
        </ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p class="description">{{ playlist.description }}</p>
        <div class="meta-row">
          <span class="likes">
            <ion-icon name="heart-outline"></ion-icon>
            {{ playlist.totalLikes }}
          </span>
          <span class="song-count">
            <ion-icon name="musical-notes-outline"></ion-icon>
            {{ playlist.songCount ?? 0 }}
          </span>
          <span *ngIf="playlist.createdByUid || playlist.createdBy" class="creator">
            {{ 'PLAYLISTS.BY' | translate }} {{ playlist.createdByUid ? (displayNames[playlist.createdByUid] || playlist.createdBy) : playlist.createdBy }}
          </span>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

<div *ngIf="showWelcomePopup" class="welcome-overlay" role="dialog" aria-modal="true" aria-labelledby="welcome-title">
  <div class="welcome-card">
    <ion-button fill="clear" class="welcome-close" (click)="closeWelcomePopup(); goToBeginning()" aria-label="Close welcome popup">
      <ion-icon name="close"></ion-icon>
    </ion-button>

    <p class="welcome-quote">{{ 'PLAYLISTS.WELCOME_QUOTE' | translate }}</p>
    <p class="welcome-attribution">{{ 'PLAYLISTS.WELCOME_ATTRIBUTION' | translate }}</p>
    <h2 id="welcome-title">{{ 'PLAYLISTS.WELCOME_TITLE' | translate }}</h2>
    <p>{{ 'PLAYLISTS.WELCOME_BODY_1' | translate }}</p>
    <p>{{ 'PLAYLISTS.WELCOME_BODY_2' | translate }}</p>
    <p>{{ 'PLAYLISTS.WELCOME_BODY_3' | translate }}</p>
    <p class="welcome-signoff">{{ 'PLAYLISTS.WELCOME_SIGNOFF' | translate }}</p>
    <img src="assets/images/logo.png" alt="LingDisco logo" class="welcome-logo" />

    <ion-button expand="block" class="welcome-cta" (click)="closeWelcomePopup(); goToBeginning()">
      {{ 'WELCOME.START_TOUR' | translate }}
    </ion-button>
  </div>
</div>

<div class="create-playlist-fab-wrapper" *ngIf="!showWelcomePopup">
  <ion-button (click)="openCreatePlaylistModal()" shape="round">
    <ion-icon name="add" slot="start"></ion-icon>
    {{ 'PLAYLISTS.CREATE_PLAYLIST' | translate }}
  </ion-button>
</div>
